import { render, staticRenderFns } from "./Filters.vue?vue&type=template&id=2e1c7538&scoped=true"
import script from "./Filters.vue?vue&type=script&lang=js"
export * from "./Filters.vue?vue&type=script&lang=js"
import style0 from "./Filters.vue?vue&type=style&index=0&id=2e1c7538&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1c7538",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/pages/Macro/Filters.vue
// module id = 1063
// module chunks = 31